import styled from "styled-components";

import { ReactComponent as InfoImage } from "./info.svg";

export const InfoIcon = styled(InfoImage)`
  width: 19px;
  height: 19px;
`;
